import client from './client';
import type { ManagedUser, CreateUserRequest, UpdateUserRequest } from '@/types/users';

export async function fetchUsers(includeInactive = true): Promise<ManagedUser[]> {
  const { data } = await client.get<ManagedUser[]>('/auth/users', {
    params: { include_inactive: includeInactive },
  });
  return data;
}

export async function createUser(body: CreateUserRequest): Promise<ManagedUser> {
  const { data } = await client.post<ManagedUser>('/auth/users', body);
  return data;
}

export async function updateUser(userId: number, body: UpdateUserRequest): Promise<ManagedUser> {
  const { data } = await client.patch<ManagedUser>(`/auth/users/${userId}`, body);
  return data;
}

export async function deleteUser(userId: number): Promise<void> {
  await client.delete(`/auth/users/${userId}`);
}

export async function fetchCustomers(): Promise<string[]> {
  const { data } = await client.get<{ customers: string[] }>('/admin/customers');
  return data.customers;
}
